module.exports = {
  login: {
    titles: 'Welcome to haihuida system',
    zhang: 'No account number',
    registerNow: 'register now',
    accountName: 'Account name',
    passwordName: 'password',
    Chinese: 'Chinese',
    English: 'English',
    account: 'account number',
    password: 'password',
    confirmPas: 'Confirm password',
    sign: 'Login',
    register: 'register',
    forget: 'Forget the password',
    code: 'Verification Code',
    emptyAcc: 'The mailbox cannot be empty',
    emptyPass: 'Password cannot be empty',
    emptyVer: 'Verification code cannot be empty',
    emptyMobile: 'Mobile phone number cannot be empty',
    Suremobile: 'Please enter the correct mobile phone number',
    Verification: 'code',
    language: 'language',
    phone: 'cell-phone number',
    Sms: 'SMS verification code',
    getCode: 'get code',
    next: 'Next',
    modify: 'You are modifying',
    email: 'Please enter email address',
    trueEmail: 'Please enter the correct email address',
    EnterPas: 'Please enter a combination of 6-20 digits of numbers and letters',
    mailbox: 'The mailbox cannot be empty'
  },
  register: {
    titles: 'Welcome to register haihuida system',
    email: 'Please fill in the email carefully',
    phone: 'Please enter your mobile phone number',
    password: 'password, 20 digits in length, with numbers and letters',
    newpassword: 'Please enter the password again',
    cancel: 'cancel',
    register: 'register',
    Email: 'Email',
    PhoneNumber: 'Phone Number',
    Password: 'Password',
    ConfirmPassword: 'Confirm Password',
    Code: 'Code',
    emptynewpas: 'Reconfirmation password cannot be empty',
    reTiao: 'You will be contacted by customer service and will jump to the login page',
    success: 'Congratulations on your successful registration！',
    Submit: 'Submit',
    equal: 'The two passwords are not equal'
  }
  // luyou: [
  //   {
  //     name: "jihua",
  //     icon: "icon-icondaxiaomobandefuben-04",
  //     children: [
  //       { path: "/jihua1", name: "jihuanguanli1" },
  //     ]
  //   },
  //   {
  //     name: "qita",
  //     icon: "icon-icondaxiaomobandefuben-04",
  //     children: [
  //       { path: "/jihua2", name: "guanli2" },
  //     ]
  //   },
  // ],
  // guan: {
  //   guan1: 'guan1',
  //   guan2: 'guan2'
  // },
  // login: {
  //   titles: 'Background management system',
  //   rember: 'Remember me',
  //   sign: 'Login',
  //   register: 'register',
  //   forget: 'Forget the password',
  //   chinese: 'chinese',
  //   English: 'English'

  // },
  // con: {
  //   chang: 'changgui',
  //   geren: 'geren'
  // },
  // left: {
  //   cai1: 'cai1',
  //   cai2: 'cai2'
  // },
  // title: {
  //   home: 'home',
  //   message: 'message',
  //   code: 'code'
  // }
}